<template lang="pug">
transition(name="modal")
  .modal-mask
    .modal-wrapper.modal.mt-5(@click.self="$modal.close()")
      .modal-dialog(role="document")
        .modal-content(v-if='!toldUs')
          .modal-header
            h3.modal-title Suggest Us Your Favourite Restaurant
          .modal-body
            .col-12
              | Email:
              input.form-control(type='text', v-model='result.email')
              br
            .col-12
              | Contact No:
              input.form-control(type='text', v-model='result.message.contact_no')
              br
            .col-12
              | Restaurant Name:
              input.form-control(type='text', v-model='result.message.restaurant_name')
              br
            .col-12
              | Restaurant Address:
              input.form-control(type='text', v-model='result.restaurant_address')
              br
            .col-12
              | Comments:
              textarea.form-control(rows='3' v-model='result.message.comments')
              br
            .col-12.text-center
              button.btn.btn-primary(type='button' @click="tellUsNow()") Submit
        .modal-content(v-if='toldUs')
            .modal-header
              h3.modal-title Got it!
            .modal-body
              .col-12
                img.img-fluid.mb-3(src='https://orig00.deviantart.net/3b19/f/2010/297/6/7/cerbolinha_em_os_tarados_by_klanpaia-d31g6gn.png')
                p Thank you for the tip, we will get to work on bringing them onboard Halal Bento right away. You will be notified once they become available.
              .col-12
                button.btn.btn-primary(type='button' @click="end()") Back
</template>

<script>
import api from '../api'

export default {
  components: {},
  name: 'Enquiry',
  props: ['eventbus'],
  data () {
    return {
      isLoading: false,
      toldUs: false,
      success: 'Thank You',
      result: {
        email: '',
        subject: 'New Restaurant Suggestion',
        source: 'bento-web-tell-us-page',
        message: {
          contact_no: '',
          retaurant_name: '',
          restaurant_address: '',
          comments: ''
        }
      }
    }
  },
  methods: {
    end () {
      this.eventbus.$emit('updated', this.success)
      this.$modal.close()
    },
    tellUsNow () {
      this.isLoading = true
      var params = {
        sender_email: this.result.email,
        data: JSON.stringify(this.result.message),
        content: JSON.stringify(this.result.message),
        subject: this.result.subject,
        source: this.result.source
      }
      api.post('/contacts/email/', params).then(response => {
        this.toldUs = true
      })
      .catch(e => {
        console.log(e)
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/EnquiryModal.vue